/**
 * Localization messages for KpiTiles component
 */
import sharedMessages from '../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../utils/localization';

const componentMessages = {
  // KPI tile titles (dashboard metrics)
  'Active Recommended Rules': 'ruleRecs.kpiTiles.activeRecommendedRules',
  'Total Active Rules': 'ruleRecs.kpiTiles.totalActiveRules',
  'Workforce Time Saved': 'ruleRecs.kpiTiles.workforceTimeSaved',

  // KPI tile subtitles (dynamic content with counts)
  '{count} Assigned access from these Rules':
    'ruleRecs.kpiTiles.assignedAccessFromRules',
  '{value} hours of total workforce time saved':
    'ruleRecs.kpiTiles.hoursWorkforceSaved',
  'N/A hours of total workforce time saved':
    'ruleRecs.kpiTiles.naHoursWorkforceSaved',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type KpiTilesMessage = keyof typeof invertedMessages;

export default invertedMessages;
